import { useSelector, useDispatch } from "react-redux"
import { checkTokenExpiration } from "../helpers/tokenHelper"
import { accountActions } from "../actions"
import backend from "../apis/backend"

const useSession = (validRoles) => {
    const token = localStorage.getItem("token")
    const account = useSelector(state => state.account)
    const { isLoggedIn, exp } = account
    const dispatch = useDispatch()

    if (token && !isLoggedIn)
        dispatch(accountActions.logIn(token))

    if (isLoggedIn) {
        // console.log(backend.defaults.headers.common["Authorization"])
        try {
            checkTokenExpiration(exp)
            backend.defaults.headers.common["Authorization"] = `Bearer ${token}`
        } catch (e) {
            dispatch(accountActions.invalidToken())
        }
    } else {
        backend.defaults.headers.common["Authorization"] = `Bearer ${token}`
    }

    const isAuthorized =
        validRoles?.includes("*") ?
            true :
            validRoles?.some(r => account.roles?.includes(r))

    return [isLoggedIn, isAuthorized]
}

export default useSession